import { render, staticRenderFns } from "./deliver-card.vue?vue&type=template&id=35e44bcb&scoped=true"
import script from "./deliver-card.vue?vue&type=script&lang=js"
export * from "./deliver-card.vue?vue&type=script&lang=js"
import style0 from "./deliver-card.vue?vue&type=style&index=0&id=35e44bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e44bcb",
  null
  
)

export default component.exports